

export class MachineReqDto {
    id:number;
    constructor(id) {
       this.id = id
    }
}